// extracted by mini-css-extract-plugin
export default {"mainContainerHeader":"Header_mainContainerHeader__ag77L","header":"Header_header__UahXU","logoHeader":"Header_logoHeader__cMxiT"};